module.exports = __webpack_public_path__ + "img/e6b1c2c4b29063486f40d81a079b0a0c.png";


//////////////////
// WEBPACK FOOTER
// ./classes/heroes/seb/assets/sprites/seb_04.png
// module id = 61
// module chunks = 0